import { useRouter as next_router } from 'next/router';

const useNavigate = () => {
    const router = next_router();

    const navigate = (url, options = {}) => {
        router.push(url, undefined, options);
    };

    return navigate;
};

const useRouter = () => {
    return next_router();
};

const reload = () => {
    window.location.reload();
};

const getParam = (param) => {
    const router = next_router();
    return typeof window !== 'undefined' ? router.query[param] : null;
};  

export { useNavigate, reload, useRouter, getParam };